/* Ferdige merdoppsett, for et anlegg ingen har tegnet ennå.
 *
 * Lusedagboka trenger rekkefølgen på merdene og omtrent hvordan de ligger --
 * nok til at merdkartet i boka ligner det mannskapet ser fra flåten. Et
 * anlegg uten oppsett får velge det som ligner mest, og numrene følger
 * rekkefølgen her. Ligger det annerledes, finnes karteditoren (Anleggskart).
 *
 * Posisjonene regnes i ringdiametre og plasseres rundt anleggets punkt med
 * samme avstand som seedPositions bruker, 1,8 diametre, så et ferdig oppsett
 * og et tegnet ett ser like ut i editoren etterpå.
 */
import { DEFAULT_CIRCUMFERENCE_M, offset, radiusM } from './merdgeo'

export type Oppsett = 'rekke' | 'ring' | 'to' | 'tre'

export const OPPSETT: { id: Oppsett; label: string }[] = [
  { id: 'rekke', label: 'På rekke' },
  { id: 'ring', label: 'I ring' },
  { id: 'to', label: 'To rekker' },
  { id: 'tre', label: 'Tre rekker' },
]

/** Øst og sør, i ringdiametre. Nummer 1 øverst til venstre, så bortover. */
export function enheter(id: Oppsett, n: number): [number, number][] {
  if (id === 'ring') {
    // Nabo-ringene én enhet fra hverandre, uansett hvor mange.
    const r = n > 1 ? 1 / (2 * Math.sin(Math.PI / n)) : 0
    return Array.from({ length: n }, (_, i) => {
      const a = (i / n) * 2 * Math.PI - Math.PI / 2
      return [r * Math.cos(a), r * Math.sin(a)]
    })
  }
  const rows = id === 'rekke' ? 1 : id === 'to' ? 2 : 3
  const cols = Math.ceil(n / rows)
  return Array.from({ length: n }, (_, i) => [i % cols, Math.floor(i / cols)])
}

/** Ekte posisjoner rundt anleggets punkt. */
export function plasser(id: Oppsett, n: number, lat: number, lon: number,
                        circumference = DEFAULT_CIRCUMFERENCE_M) {
  const step = radiusM(circumference) * 2 * 1.8
  const pts = enheter(id, n)
  const cx = (Math.min(...pts.map((p) => p[0])) + Math.max(...pts.map((p) => p[0]))) / 2
  const cy = (Math.min(...pts.map((p) => p[1])) + Math.max(...pts.map((p) => p[1]))) / 2
  return pts.map(([x, y]) => {
    const [lo, la] = offset(lat, lon, (x - cx) * step, -(y - cy) * step)
    return { lat: la, lon: lo }
  })
}
